document.addEventListener('DOMContentLoaded', function () {

    const addBackButtons = () => {
        const subMenus = document.querySelectorAll('.mega-menu > ul.sub-menu');

        subMenus.forEach(subMenu => {
            // ✅ Vérifie si un backButton existe déjà
            if (subMenu.querySelector('.arrow-backward')) return;

            // Seulement sur mobile
            if (window.innerWidth > 1200) return;

            const parentLink = subMenu.previousElementSibling; // le .nav-link juste avant le sous-menu
            const backButton = document.createElement('span');
            backButton.className = 'arrow-backward';
            backButton.textContent = '' + (parentLink ? parentLink.textContent.trim() : 'Retour');
            subMenu.insertBefore(backButton, subMenu.firstChild);

            // Clic sur backButton pour fermer
            backButton.addEventListener('click', function () {
                subMenu.classList.remove('is-open');
            });
        });
    };

    // ----------------------------
    // Gestion de l'ouverture sur mobile
    // ----------------------------
    const menuLinks = document.querySelectorAll('.mega-menu > .nav-link');

    menuLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            if (window.innerWidth > 1200) return; // uniquement mobile

            const submenu = this.nextElementSibling;

            if (!submenu || !submenu.classList.contains('sub-menu')) return;

            e.preventDefault(); // bloquer le lien
            submenu.classList.add('is-open');

            // Ajouter backButton si pas déjà présent
            addBackButtons();
        });
    });

    // ✅ Initialisation au chargement
    addBackButtons();

    // 🔄 Optionnel : réajouter/retirer backButtons au redimensionnement
    window.addEventListener('resize', addBackButtons);


    //AJOUT BURGER MENU

    const menuPrimary = document.getElementById('menu-primary');

    // Fonction pour créer le burger menu sur mobile
    const addBurgerMenu = () => {
        // Si on est sur desktop, retirer si jamais il existe
        if (window.innerWidth > 1200) {
            const existingBurger = menuPrimary.querySelector('.burger-menu');
            if (existingBurger) existingBurger.remove();
            return;
        }

        // Vérifie si le burger existe déjà
        if (menuPrimary.querySelector('.burger-menu')) return;

        // Création de l'élément li
        const li = document.createElement('li');
        li.className = 'nav-item menu-root-item burger-menu';

        // Création du lien
        const a = document.createElement('a');
        a.href = '#'; // lien non-fonctionnel
        a.className = 'nav-link';

        // Création des images
        const imgOpen = document.createElement('img');
        imgOpen.src = urlDuTheme + '/img/burger-open.png';
        imgOpen.alt = 'Menu ouvert';
        imgOpen.className = 'burger-open';

        const imgClose = document.createElement('img');
        imgClose.src = urlDuTheme + '/img/burger-close.png';
        imgClose.alt = 'Menu fermé';
        imgClose.className = 'burger-close';

        a.appendChild(imgOpen);
        a.appendChild(imgClose);
        li.appendChild(a);

        // Ajout au menu
        menuPrimary.appendChild(li);

        // Toggle de la classe .is-open sur #menu-primary
        li.addEventListener('click', function (e) {
            e.preventDefault(); // éviter le scroll vers le haut
            menuPrimary.classList.toggle('is-open');
        });
    };

    // Initialisation au chargement
    addBurgerMenu();

    // Réajout/retirer burger au redimensionnement
    window.addEventListener('resize', addBurgerMenu);

});